
<template>

<div>
 <MenuPantallaStore @update-buscador="buscador = $event"
                     @update-categoria="categoriaSeleccionada = $event"

                      @update-vendedor="vendedorSeleccionado = $event"
 ></MenuPantallaStore> 
  <MenuMovilStore></MenuMovilStore> 
 <CoreViewStore :buscador="buscador" :categoriaSeleccionada="categoriaSeleccionada"
 
 :vendedorSeleccionado="vendedorSeleccionado"
 ></CoreViewStore> 
 <FooterPerfilStore></FooterPerfilStore>
  <!-- <PerfilOpciones></PerfilOpciones>   Boton redondo con opciones.-->
</div>
</template>
<script>


import CoreViewStore from '@/components/common/ViewStore'

import MenuPantallaStore from '@/components/base/MenuPantallaStore.vue'
import MenuMovilStore from '@/components/base/MenuMovilStore.vue'

import PerfilOpciones from '@/components/common/PerfilOpciones.vue';


import FooterPerfilStore from '@/components/common/FooterPerfilStore';

export default {
  name: 'MenuStorePrincipal',

  components: {
    CoreViewStore,
    MenuPantallaStore,
    MenuMovilStore,
        FooterPerfilStore,
        PerfilOpciones
  },
  data() {
    return {
      buscador: ""  ,
      categoriaSeleccionada: "todos", 
      vendedorSeleccionado: 'all' 
    };
  }
};




</script>
